// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blaziken_mega: PokeData = {
  "id": 10050,
  "name": "blaziken-mega",
  "height": 19,
  "weight": 520,
  "base_experience": 284,
  "types": [
    PokeType.FIRE,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "fire-punch",
    "scratch",
    "double-kick",
    "sand-attack",
    "growl",
    "ember",
    "peck",
    "quick-attack",
    "focus-energy",
    "high-jump-kick",
    "slash",
    "blaze-kick",
    "sky-uppercut",
    "bulk-up",
    "flare-blitz",
    "brave-bird",
    "flame-charge"
  ],
  "moves": [
    "fire-punch",
    "scratch",
    "double-kick",
    "growl",
    "ember",
    "peck",
    "quick-attack",
    "blaze-kick",
    "bulk-up",
    "flare-blitz",
    "brave-bird",
    "fire-ball",
    "rolling-kick"
  ],
  "evolution_chain": {
    "id": 131,
    "item": null,
    "species": [
      {
        "name": "torchic",
        "order": 280,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "combusken",
        "order": 281,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 255,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blaziken",
        "order": 282,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 256,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 118,
    "ability_power": 188
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
